import {
  ECourseTabSectionKey,
  TEnterpriseProfileCourseTabSection,
} from './course_tab.interface';
import {
  EDegreeTabSectionKey,
  TEnterpriseProfileDegreeTabSection,
} from './degree_tab.interface';
import {
  EHomepageTabSectionKey,
  TEnterpriseProfileHomepageTabSection,
} from './homepage_tab.interface';
import {
  EInformationTabSectionKey,
  TEnterpriseProfileInformationTabSection,
} from './information_tab.interface';
import {
  EMemberTabSectionKey,
  TEnterpriseProfileMemberTabSection,
} from './member_tab.interface';
import {
  EVideoTabSectionKey,
  TEnterpriseProfileVideoTabSection,
} from './video_tab.interface';

export enum EEnterpriseTabKey {
  HomePage = 'HomePage',
  Information = 'Information',
  Member = 'Member',
  Course = 'Course',
  Degree = 'Degree',
  Video = 'Video',
}

export type TEnterpriseTabSection =
  | TEnterpriseProfileHomepageTabSection
  | TEnterpriseProfileMemberTabSection
  | TEnterpriseProfileInformationTabSection
  | TEnterpriseProfileCourseTabSection
  | TEnterpriseProfileDegreeTabSection
  | TEnterpriseProfileVideoTabSection;

export type TEnterpriseSectionKey =
  | EVideoTabSectionKey
  | EMemberTabSectionKey
  | EInformationTabSectionKey
  | EHomepageTabSectionKey
  | EDegreeTabSectionKey
  | ECourseTabSectionKey;

export interface IEnterpriseProfileStructureJSON {
  structure: {
    tabName: string;
    tabKey: EEnterpriseTabKey;
    sections: TEnterpriseTabSection;
    isActive: boolean;
  }[];
}
